// extracted by mini-css-extract-plugin
export default {"container":"jN-z","error":"kN-z","disabled":"lN-z","submit":"mN-z","option":"nN-z","success":"oN-z","failure":"pN-z"};